var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['newdrawLots', { inApp: _vm.$root.$data.isApp }]},[_c('common-title',{attrs:{"titleName":"抽签活动","bcColor":'#fff',"zIndex":1000}}),_c('section',{staticClass:"section"},[_c('div',{staticClass:"drawWarrp"},[_c('img',{staticClass:"chou",attrs:{"src":_vm.imgUrls[0],"alt":""},on:{"click":_vm.drawBtn}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }